import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

/** Brand-detail layout — E3 Settings · E4 Access · E5 Playbook. */
export const Route = createFileRoute('/_ws/w/$workspaceId/brands/$brandId')({
  beforeLoad: ({ params }) => {
    // Brand ids are `brand_{uuid}` (real) / `brand_NNNNNN` (mock) — reject a path
    // segment that couldn't be one so a bad link never renders an empty console.
    if (!/^[\w-]+$/.test(params.brandId)) throw notFound()
  },
  component: Outlet,
})
